"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SCHEMA = 'iglu:com.angi.entities/brand_attributes/jsonschema/1-0-0';
var allowedBrands = ['ANGI', 'HOME_ADVISOR'];
var potentialHABrandNames = ['HOMEADVISOR', 'HOME ADVISOR', 'HA'];
/**
 * Generates the brand_attributes context
 *
 * @param brandName - brand name
 */
var brandAttributesContext = function brandAttributesContext(brandName) {
  var capitalizedBrandName = brandName.toUpperCase();
  if (potentialHABrandNames.includes(capitalizedBrandName)) {
    capitalizedBrandName = 'HOME_ADVISOR';
  }
  if (!allowedBrands.includes(capitalizedBrandName)) {
    console.warn("Invalid brand name \"".concat(brandName, "\". Please use one of the following: ").concat(allowedBrands.join(', ')));
    return;
  }
  return {
    schema: SCHEMA,
    data: {
      name: capitalizedBrandName
    }
  };
};
exports["default"] = brandAttributesContext;